import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router";
import { useParams } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import { useRecoilState, } from 'recoil';
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { popupCustomerFlowAtom } from '../../state';
import { EXTERNAL_PORT_FEE_CATEGORY_ID, INGREDIENT_CATEGORY_ID, INGREDIENT_OTHER_NOT_NEED_REQUEST, MONEY_TYPE } from "../../utils/Utils";


const VIEW_DATE_FORMAT = "DD/MM/YYYY";
const MONEY_FLOW_TYPE = {
  IN: "Thu",
  OUT: "Chi",
};

const MONEY_TYPE_OPTIONS = Object.keys(MONEY_TYPE).map((c) => ({
  label: MONEY_TYPE[c],
  value: c,
}));

const CustomerMoneyFlowByCustomer = () => {
  const history = useHistory();
  const { customerId } = useParams();
  const clearPagi = useRef();
  const [popupCustomerFlow, setPopupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);

  const [data, setData] = useState([]);
  const [view, setView] = useState({
    edit: false,
    add: false,
    details: false,
    isDelete: false,
  });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [onSearchText, setSearchText] = useState("");
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [updatedAt, setUpdatedAt] = useState();
  const [displayMoneyFLowCol, setDisplayMoneyFLowCol] = useState(1);

  const [filter, setFilter] = useState({
    type: searchParams.get('type') || undefined,
    bankAccountId: searchParams.get('bankAccountId') || undefined,
  });
  const [bankAccountOptions, setBankAccountOptions] = useState([]);

  const [customerData, setCustomerData] = useState({});
  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("months").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({ start: start ? moment(start)?.startOf('days').toDate() : start, end: end ? moment(end)?.endOf('days').toDate() : end });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  const colTable = [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format(VIEW_DATE_FORMAT),
    },
    {
      Header: "Loại",
      accessor: (item) => MONEY_FLOW_TYPE[item.type],
    },

    {
      Header: "Quỹ tài khoản",
      accessor: (item) => item.bankAccount?.name || "",
    },
    ...(displayMoneyFLowCol === 1 ? [
      {
        Header: "Số tiền Thu(đ)",
        className: 'text-right',
        accessor: (item) => item.type === 'IN' ? <NumericFormat
          displayType={"text"}
          value={item?.amount || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        /> : '',
      },
      {
        Header: "Số tiền Chi(đ)",
        className: 'text-right',
        accessor: (item) => item.type === 'OUT' ? <NumericFormat
          displayType={"text"}
          value={item?.amount || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        /> : '',
      },
    ] : []),
    ...(displayMoneyFLowCol === 2 ? [
      {
        Header: "Số tiền(đ)",
        className: 'text-right',
        accessor: (item) => <NumericFormat
          displayType={"text"}
          value={item?.amount || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />,
      },
    ] : []),

    {
      Header: "Nội dung",
      accessor: (item) => item.content || "",
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.note || "",
    },
    {
      Header: "Người nhận",
      accessor: (item) => item.receiver || "",
    },

    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        if (item.billId) {
                          const ingredientId = item?.bill?.ingredientId;


                          if (!!EXTERNAL_PORT_FEE_CATEGORY_ID[ingredientId]) {
                            history.push(`/bill-external-port-fee/${item.billId}`)
                          } else if (!!INGREDIENT_CATEGORY_ID[ingredientId]) {
                            history.push(`/bill/${item.billId}`)
                          } else if (!!INGREDIENT_OTHER_NOT_NEED_REQUEST[ingredientId]) {
                            history.push(`/bill-other/${item.billId}`)
                          } else {
                            history.push(`/bill-other-must-request/${item.billId}`)
                          }
                        } else {
                          setPopupCustomerFlow({
                            show: true,
                            data: {
                              id: item.id,
                              type: item.type,

                            },
                          });
                        }
                      }}
                    >
                      <Icon name={"edit"}></Icon>
                      <span>{"Cập nhật"}</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];


  useEffect(() => {
    GET(`customer/${customerId}`, {}, true).then((resp) => {
      setCustomerData(resp.data)
    });
    GET(`bank-account`, {}, true).then((resp) => {
      setBankAccountOptions(
        resp.data.map((c) => ({
          label: `${c.name}`,
          value: c.id,
          data: c,
        }))
      );
    });
  }, []);

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(onSearchText ? { onSearchText } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.bankAccountId ? { bankAccountId: filter.bankAccountId } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        customerId,
        ...(onSearchText ? { onSearchText } : {}),
        ...(filter.type ? { type: filter.type } : {}),
        ...(filter.bankAccountId ? { bankAccountId: filter.bankAccountId } : {}),
        start: moment(rangeDate.start).format('YYYY-MM-DD'),
        end: moment(rangeDate.end).format('YYYY-MM-DD'),
      };
      if (onSearchText !== "") {
        params.search = onSearchText;
      }

      GET(`customer-money-flow`, params, true)
        .then(({ data }) => {
          setData([...data?.rows]);
          setSummary({
            ...data.summary,
            count: data.count,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [onSearchText, timeNow, filter, updatedAt, popupCustomerFlow.updatedAt]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setSearchText("");
    setTimeNow(moment().valueOf());
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`customer-money-flow/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa thanh toán tải thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <React.Fragment>
      <Head title="Quản lý thanh toán"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Dòng tiền</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <Button className={'btn btn-info'} onClick={() => setDisplayMoneyFLowCol(displayMoneyFLowCol === 1 ? 2 : 1)}>{displayMoneyFLowCol === 1 ? 'Gộp cột tiền' : 'Chia cột tiền'}</Button>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <DatePicker
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          dateFormat={'dd/MM/yy'}
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          endDate={rangeDate.end}
                          onChange={onRangeChange}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>

                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Lọc quỹ tài khoản"
                          classNamePrefix="form-control"
                          options={bankAccountOptions}
                          value={bankAccountOptions.find(
                            (c) => c.value === filter.bankAccountId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              bankAccountId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          classNamePrefix="form-control"
                          isClearable
                          placeholder="Lọc loại tiền"
                          options={MONEY_TYPE_OPTIONS}
                          value={MONEY_TYPE_OPTIONS.find(
                            (c) => c.value === filter.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          placeholder="Tìm kiếm giao dịch"
                          className="form-control  border-primary"
                          value={onSearchText}
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>

                    <li>

                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start">
                    {customerData?.type === 'IN' ? 'Nhà cung cấp' : 'Khách hàng'}: {customerData?.name}
                    <br />
                    Dòng tiền(đ): <NumericFormat
                      displayType={"text"}
                      value={customerData?.amount || 0}
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      decimalScale={2}
                    />
                  </div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    notShowPagi={true}
                    loading={loading}
                    columns={colTable}
                    data={data}
                    headerRow={(<tr className="nk-tb-item odd font-weight-bold" style={{ backgroundColor: "#feff98" }}>
                      <td className="nk-tb-col">
                        Tổng thu
                      </td>
                      <td className="nk-tb-col text-right" colSpan={2}>
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.totalAmountIn || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td>
                        Tổng chi
                      </td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={Math.abs(summary?.totalAmountOut || 0)}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td colSpan={2}>Tổng cộng</td>
                      <td colSpan={2} className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.totalAmount || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                    </tr>
                    )}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá thanh toán này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default CustomerMoneyFlowByCustomer;
